// Platform surface detection. Loaded once before anything else renders.
// API calls go same-origin when the page is served from a tenant / custom domain so the Host header
// resolves the company server-side; on the configured backend host (preview) we use REACT_APP_BACKEND_URL.
const ENV_ORIGIN = process.env.REACT_APP_BACKEND_URL;

export const apiOrigin = () => {
  try {
    const envHost = new URL(ENV_ORIGIN).host;
    const here = window.location.host;
    if (here && here !== envHost && !/^(localhost|127\.0\.0\.1)(:\d+)?$/.test(here)) return window.location.origin;
  } catch (e) { /* fall through */ }
  return ENV_ORIGIN;
};

const DEFAULT = { mode: 'combined', host: '', platform: { name: 'Platform', app_url: '', marketing_url: '', support_email: '' }, company: null, redirect_to: null };
let site = { ...DEFAULT };

// Preview-only surface simulation: /?__site=platform|app|admin or /?__site=storefront&company=<slug>.
// Persisted for the tab; the backend honours the headers only on dev/preview hosts.
export const previewHeaders = () => {
  const params = new URLSearchParams(window.location.search);
  if (params.get('__site')) {
    sessionStorage.setItem('site_preview', params.get('__site'));
    if (params.get('company')) sessionStorage.setItem('site_preview_company', params.get('company'));
    if (params.get('store')) sessionStorage.setItem('site_preview_store', params.get('store'));
    if (params.get('__site') === 'clear') { sessionStorage.removeItem('site_preview'); sessionStorage.removeItem('site_preview_company'); sessionStorage.removeItem('site_preview_store'); }
  }
  const sim = sessionStorage.getItem('site_preview');
  if (!sim || sim === 'clear') return {};
  const h = { 'X-Site-Preview': sim };
  const slug = sessionStorage.getItem('site_preview_company');
  if (slug) h['X-Site-Company'] = slug;
  const store = sessionStorage.getItem('site_preview_store');
  if (store) h['X-Site-Store'] = store;
  return h;
};

export const getSite = () => site;
export const siteMode = () => site.mode;
export const platformName = () => site.platform?.name || DEFAULT.platform.name;
export const appUrl = () => site.platform?.app_url || window.location.origin;
export const marketingUrl = () => site.platform?.marketing_url || '/';
export const supportEmail = () => site.platform?.support_email || '';
export const selfSignupEnabled = () => site.platform?.self_signup !== false;
export const isPlatformSurface = () => ['platform', 'app', 'admin'].includes(site.mode);

export const loadSiteContext = async () => {
  try {
    const r = await fetch(`${apiOrigin()}/api/public/site-context`, { headers: previewHeaders() });
    if (r.status === 404) { site = { ...DEFAULT, mode: 'unknown', host: window.location.host }; return site; }
    if (r.ok) site = { ...DEFAULT, ...(await r.json()) };
  } catch (e) { /* offline: keep combined defaults */ }
  if (site.redirect_to && ['storefront', 'store'].includes(site.mode) && !sessionStorage.getItem('site_preview')) {
    window.location.replace(`${site.redirect_to}${window.location.pathname}${window.location.search}`);
  }
  return site;
};
